<template>
  <div class="items-center gap-0.5 p-0.5 rounded-lg bg-neutral-25 overflow-hidden flex-shrink-0"
  :class="useParentWidth ? 'w-full grid grid-cols-2' : 'w-max flex'">
    <button v-for="platform in platformOptions" :key="`toggle-${platform.name}`" class="platform-toggle-btn"
    :class="{'active': platform.isActive}" @click="platform.action">
      <component :is="platform.icon" :width="16" :height="16" />
      <BaseText type="label" size="sm" class="px-1">
        {{ platform.name }}
      </BaseText>
    </button>
  </div>
</template>

<script>
import MetaPlatformIcon from '../globals/Icons/FilterIcons/Platforms/MetaPlatformIcon.vue'
import TikTokPlatformIcon from '../globals/Icons/FilterIcons/Platforms/TikTokPlatformIcon.vue'

export default {
  name: 'PlatformToggle',
  props: {
    currentPlatform: {
      type: String,
      required: true
    },
    useParentWidth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    platformOptions () {
      return [
        {
          name: 'Meta',
          icon: MetaPlatformIcon,
          action: () => this.$emit('select', 'meta'),
          isActive: this.currentPlatform === 'meta'
        },
        {
          name: 'TikTok',
          icon: TikTokPlatformIcon,
          action: () => this.$emit('select', 'tiktok'),
          isActive: this.currentPlatform === 'tiktok'
        }
      ]
    }
  }
}
</script>

<style scoped>
.platform-toggle-btn {
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 6px 12px;
  border-radius: 6px;
  color: #5E6678;
  background-color: transparent;
  box-shadow: none;
  transition: background-color 100ms ease-in-out, color 100ms ease-in-out, box-shadow 100ms ease-in-out;
}
.platform-toggle-btn:not(.active):hover {
  background-color: #ECEFF3;
  color: #303546;
}
.platform-toggle-btn.active {
  background-color: white;
  color: #303546;
  box-shadow: 0 36px 48px -12px rgba(53, 57, 75, 0.20), 0 24px 32px -12px rgba(53, 57, 75, 0.24), 0 1px 2px 0 rgba(162, 172, 186, 0.16);
}
</style>